import React, { Component } from "react";
import axios from "../../utils/axiosInstance";

import HomeSearchBar from "../../components/frontend/HomeSearchBar";
import PostSlider from "../../components/frontend/PostSlider";
import PostSlider_New_Arrivals from "../../components/frontend/PostSlider_New_Arrivals";
import PostSlider_Recently_Viewed from "../../components/frontend/PostSlider_Recently_Viewed";
import Staytype from "../../components/frontend/Staytype";
import PopularDestinations from "../../components/frontend/PopularDestinations";
import TravelServices from "../../components/frontend/TravelServices";
import Blogs from "../../components/frontend/Blogs";
import PerfectStayCTA from "../../components/frontend/PerfectStayCTA";
import TestimonialSlider from "../../components/frontend/TestimonialSlider";
import Footer2 from "../../components/frontend/Footer";
import HeroBanner from "../../components/frontend/HeroBanner";
import WhyBooklyChoice from "../../components/frontend/WhyBooklyChoice";
import RoomCollection from "../../components/frontend/RoomCollection";
import AndroidBanner from "../../components/frontend/AndroidBanner";

class HomePage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      isLoading: true,
      error: null,
      hasRecentlyViewed: false,
    };
  }

  componentDidMount() {
    const viewedProducts =
      JSON.parse(
        localStorage.getItem("recently_viewed_products")
      ) || [];

    this.setState({
      hasRecentlyViewed: viewedProducts.length > 0,
    });

    this.fetchCategories();
  }

  fetchCategories = async () => {
    try {
      const res = await axios.get("/get_category");

      const categories = Array.isArray(res.data?.data)
        ? res.data.data
        : [];

      this.setState({
        categories,
        isLoading: false,
      });
    } catch (error) {
      console.error("Category Load Error:", error);

      this.setState({
        error: "Failed to load categories",
        isLoading: false,
      });
    }
  };

  render() {
    
    const {
      categories,
      isLoading,
      error,
      hasRecentlyViewed,
    } = this.state;

    return (
      <>
        <div style={{ backgroundColor: "#F8F9FA"}}>

          <HeroBanner />
          <HomeSearchBar />
          <Staytype />
          <PopularDestinations />
          <RoomCollection />
          <WhyBooklyChoice />
          <TravelServices />
          <Blogs />
          <TestimonialSlider />
          <PerfectStayCTA />
          <AndroidBanner />

          {/* <br />

          {hasRecentlyViewed && (
            <PostSlider_Recently_Viewed
              sliderId="recently-viewed"
              title="Recently Viewed"
            />
          )}

          <PostSlider_New_Arrivals
            sliderId="new-arrivals"
            title="New Arrivals"
          />

          {!isLoading &&
            categories.map((category) => (
              <PostSlider
                key={category.id}
                sliderId={`category-${category.id}`}
                title={category.category_name}
                category_id={category.id}
              />
            ))}

          {error && (
            <div className="container">
              <div className="alert alert-danger">
                {error}
              </div>
            </div>
          )} */}

        
        </div>
      </>
    );
  }
}

export default HomePage;
